<template>
  <v-container>
    <v-row class="text-center">
      <banners-slider :items="bannerItems" />
      <charts-slider />
      <tabs />
    </v-row>
  </v-container>
</template>

<script>
import BannersSlider from '@/components/Home/Widgets/BannersSlider'
import ChartsSlider from '@/components/Home/Widgets/ChartsSlider'
import Tabs from '@/components/Home/Tabs'

export default {
  name: 'Home',
  components: {
    BannersSlider,
    ChartsSlider,
    Tabs
  },
  data: () => ({
    bannerItems: [
      {
        src: 'https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg',
      },
      {
        src: 'https://cdn.vuetifyjs.com/images/carousel/sky.jpg',
      },
      {
        src: 'https://cdn.vuetifyjs.com/images/carousel/bird.jpg',
      },
      {
        src: 'https://cdn.vuetifyjs.com/images/carousel/planet.jpg',
      }
    ],
    tab: 0,
    tabs: [
      { name: 'Auction Feed', icon: 'mdi-account' },
      { name: 'Inventory', icon: 'mdi-account-outline' }
    ]
  })
}
</script>
